<template>
  <div>
    <div v-if="canShowContent">
      <Content
        model="page"
        :content="content"
        :api-key="apiKey"
        :data="{}"
        class="builder-io-hero-content"
      />
    </div>
  </div>
</template>
<script>
import { attribute, customAttributeValueNew } from "@/services/util.service";
import imageData from "@/assets/c4aa164d9b01387a88228c67620f7faf861b5544.png";
const mediaImageUrl = import.meta.env.VITE_APP_MEDIA_IMAGES_API_URL;
const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY;

import { Content, fetchOneEntry, isPreviewing } from "@builder.io/sdk-vue";

export default {
  name: "BuilderIoPageContent",
  components: {
    Content,
  },
  props: ["breadcrumbData", "categoryContent"],
  computed: {
    isIpad: function () {
      return this.$vuetify.display.smOnly || this.$vuetify.display.mdOnly
        ? true
        : false;
    },
    isIpadOrMobile: function () {
      return this.$vuetify.display.mdAndDown ? true : false;
    },
    categoryListIdWise: function () {
      return this.$store.state.headerCategoryList.categoryListIdWise;
    },
    productAttributes() {
      return this.$store.state.productList.attributeList;
    },
    lazyLoadImagePathUrl() {
      return import.meta.env.VITE_LAZY_SRC_URL;
    },
    imageBasePathUrl() {
      return import.meta.env.VITE_IMAGE_PATH_URL;
    },
    imageBaseParams() {
      return import.meta.env.VITE_IMAGE_CATEGORY_PARAMS;
    },

    heroContent() {
      return this.$store.state.layout.heroContent;
    },
    getImageHeight() {
      if (this.$vuetify.display.lgAndUp) {
        return "454";
      } else if (this.$vuetify.display.mdOnly) {
        return "406";
      } else if (this.$vuetify.display.smOnly) {
        return "300";
      }
      return "454";
    },
    newUser() {
      if (this.$vuetify.display.smAndDown) return false;
      let userVisits = this.$store.state.layout.user.userVisits;
      if (userVisits && Number(userVisits) > 1) return false;
      else return true;
    },
    routeName: function () {
      return this.$route.fullPath;
    },
  },
  data: () => ({
    mediaImageUrl,
    variants: [1366, 768, 360],
    heroImageHeight: "454",
    heroImageWidth: "454",
    heroData: {
      image: imageData,
    },
    content: null,
    canShowContent: false,
    modelName: "page",
    apiKey,
    inprogress: false,
  }),
  watch: {
    heroContent: function () {
      this.builderioCheck();
    },
  },
  methods: {
    fetchProductImageName(imageFullName) {
      if (imageFullName) {
        let fileExtention = imageFullName.split("/");
        let filename = fileExtention[fileExtention.length - 1].split(".")[0];
        return filename;
      } else {
        return "";
      }
    },
    setImage() {
      event.target.src = this.heroData.image;
    },

    categoryImageBasePathUrl() {
      return import.meta.env.VITE_MAGENTO_API_URL;
    },
    getCustomAttributeValue(customAttributes, attributeCode) {
      return customAttributeValueNew(customAttributes, attributeCode);
    },
    getImageCustomAttributeValue(customAttributes, attributeCode) {
      let imagePath = customAttributeValueNew(customAttributes, attributeCode);
      if (imagePath == "") {
        return undefined;
      } else if (imagePath.includes("/media/catalog/category/")) {
        return this.categoryImageBasePathUrl() + imagePath;
      } else if (!imagePath.includes("/media/catalog/category/")) {
        return (
          this.categoryImageBasePathUrl() +
          "/media/catalog/category/" +
          imagePath
        );
      } else {
        return this.heroData.image;
      }
    },

    getAttribute(customAttributes, attributeCode) {
      return attribute(customAttributes, attributeCode, this.productAttributes);
    },

    getCustomAttributeValue(customAttributes, attributeCode) {
      return customAttributeValueNew(customAttributes, attributeCode);
    },
    async loadContent() {
      let vm = this;
      vm.inprogress = false;
      vm.content = await fetchOneEntry({
        model: "page",
        apiKey: vm.apiKey,
        userAttributes: {
          urlPath: "/homepage",
        },
      });
      vm.inprogress = true;
      vm.canShowContent = vm.content ? true : isPreviewing();
    },
  },
  async mounted() {
    this.loadContent();
  },
  created() {},
};
</script>
<style lang="scss">
.categorybaseproducts-filter-button .v-input__control .v-input__slot {
  padding-left: 10px !important;
}
.categorybaseproducts-filter-button .v-input__control .v-input__slot {
  border: thin solid #3d5789 !important;
}
.categorybaseproducts-filter-button:hover .v-input__control .v-input__slot {
  border: thin solid #3d5789 !important;
}
.categorybaseproducts-filter-button.v-input--is-label-active.v-input--is-focused
  .v-select__selection.v-select__selection--comma {
  color: #3d5789 !important;
}
.categorybaseproducts-filter-button.v-input--is-label.v-input
  .v-select__selection.v-select__selection--comma {
  color: #3d5789 !important;
}
.categorybaseproducts-filter-button:hover
  .v-select__selection.v-select__selection--comma {
  color: #3d5789 !important;
}
.categorybaseproducts-filter-button .theme--light.v-label {
  color: #3d5789 !important;
}
.categorybaseproducts-sortby-button.theme--light.v-select
  .v-select__selection--comma {
  color: #3d5789 !important;
}
.categorybaseproducts-filter-button:hover
  .v-input__append-inner
  .v-input__icon
  .v-icon {
  color: #3d5789 !important;
}
.categorybaseproducts-filter-button
  .v-input__append-inner
  .v-input__icon
  .v-icon {
  color: #3d5789 !important;
  font-size: 24px !important;
}
.categorybaseproducts-filter-button.v-input--is-label-active.v-input--is-focused
  .v-input__control
  .v-input__slot {
  border: thin solid #3d5789 !important;
}

.categorybaseproducts-filter-button
  .v-input__control
  .v-select__slot
  .v-select__selections {
  justify-content: center;
}
.categorybaseproducts-filter-button.v-select.v-text-field input {
  display: none;
}

.close-filter-button.v-btn:not(.v-btn--text):not(
    .v-btn--outlined
  ):focus:before {
  opacity: 0 !important;
}

.close-filter-button.v-btn:not(.v-btn--text):not(
    .v-btn--outlined
  ):hover:before {
  opacity: 0 !important;
}

.categorybaseproduct-hero-image .v-image__image--cover {
  background-size: 100% 100% !important;
}
</style>
